<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="410px"
    title=""
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    class="investor-wrapper"
  >
    <div class="tip">
      <img class="tip-img" src="@/assets/image/shield.png" alt="">
      <span class="tip-text">根据相关监管规定，我司需要对浏览私募产品等非公开信息的投资者进行特定对象确认及身份核实，并对您的风险识别能力和风险承担能力进行评估。</span>
    </div>
    <div class="code-wrapper">
      <div class="code-title">请使用微信扫一扫，完成相关操作：</div>
      <div class="code-img" v-loading="imgLoading">
        <img :src="qrCodeUrl" alt="" class="code">
      </div>
      <div class="code-btn">
        <el-button type="primary" class="btn" @click.stop="confirm">已完成操作</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { getLcWeb } from '@/api/lc_web'
import { getWcWeb, authAddString } from '@/api/wc_web'
export default {
  props: {
    detail: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      dialogVisible: false,
      qrCodeUrl: '',
      imgLoading: false
    }
  },
  methods: {
    handleClose () {
      this.dialogVisible = false
    },
    show (val) {
      this.init(val)
      this.dialogVisible = true
    },
    async confirm () {
      if (!this.$store.state.user.token) {
        return
      }
      const obj = {
        name: 'lc.app.live.canView',
        data: {
          userNo: this.$store.state.user.uid,
          liveId: this.detail.id
        }
      }
      const res = await getLcWeb(obj)
      if (res.code === 0) {
        if (res.value === true) {
          this.$emit('confirm')
        } else {
          this.$showError('验证未通过')
        }
      } else {
        this.$showError(res.msg)
      }
    },
    async init (val = this.detail) {
      this.qrCodeUrl = ''
      this.imgLoading = true
      const obj1 = {
        name: 'webapi.auth.addstring',
        data: {
          stringUrl: JSON.stringify({
            id: val.id,
            faOutId: this.$route.query.outId ? this.$route.query.outId : ''
          })
        }
      }
      const res = await authAddString(obj1)
      const obj2 = {
        name: 'wechat.wxacode',
        data: {
          sourceCode: 'wbs_investor',
          // scene: res.value,
          scene: `id=${res.value}&source=pc`,
          width: '430',
          auto_color: false,
          line_color: '',
          is_hyaline: false,
          page: 'pages/liveMarketing/liveMarketing'
        }
      }
      const res2 = await getWcWeb(obj2)
      this.imgLoading = false
      if (res2.code === 0) {
        const str = 'data:image/png;base64,' + res2.value
        this.qrCodeUrl = str
      } else {
        this.dialogVisible = false
        this.$showError(res2.msg)
      }
    }
  },
  created () {
    // this.init()
  }
}
</script>
<style scoped lang="scss">
.investor-wrapper ::v-deep .el-dialog__header{
  padding-top: 0;
  .el-dialog__headerbtn {
    top: 10px;
    right: 10px;
  }
}
.tip {
  display: flex;
  align-items: center;
  border: 1px solid #2179FF;
  padding: 10px;
  border-radius: 5px;
  .tip-img {
    width: 30px;
    height: 30px;
    margin-right: 10px
  }
  .tip-text {
    font-size: 13px;
    color: #2179FF
  }
}
.code-wrapper {
  margin-top: 10px;
  .code-img {
    text-align: center;
  }
  .code-btn {
    text-align: center;
    ::v-deep .el-button--primary {
      width: 60%;
    }
  }
}
.code {
  width: 180px;
  height:180px;
  margin: 34px 48px;
  background: #ffffff;
}
</style>
